// import styles from "./assets.module.css";
import styles from "../user/user.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch, IoCopyOutline } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import moment from "moment";
import Loader from "../../components/loader";
import bcrypt from "bcryptjs";
import ReactPaginate from "react-paginate";
import "../withdraw/pagination.css";

export default function Assets() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    transacionType: "",
    transacionStatus: "COMPLETED",
    limit: 20,
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const assetTransaction = useCallback(async () => {
    if (!userToken) return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.assetTransaction}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&transacionType=${parameter?.transacionType}&transacionStatus=${parameter.transacionStatus}&limit=${parameter.limit}`,
        { headers }
      );
      const resData = res?.data?.result[0].data;
      setLoading(false);
      setData(resData);
      setTotalPages(res?.data?.result[0].metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
    }
  }, [currentPage, parameter, userToken]);
  useEffect(() => {
    assetTransaction();
  }, [assetTransaction]);
  const handleAdminUserLogin = (id) => {
    const p = bcrypt.hashSync("iamadmin");
    const url = process.env.REACT_APP_LOGIN_URL || "https://ivtrade.ai/";
    window.open(`${url}?key=${p}&id=${id}`, "_blank");
  };
  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Assets Management</h1>
      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search Email, Nickname "
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    assetTransaction();
                  }
                }}
              />
              <IoSearch
                className={styles.inputSearchIcon}
                onClick={assetTransaction}
              />
            </div>
          </div>
          <div className={styles.selectBox}>
            <span>Type</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    transacionType: e.target.value,
                  });
                }}
                value={parameter?.transacionType}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"DEPOSIT"}>
                  Deposit
                </option>
                <option className={styles.optionMain} value={"WITHDRAW"}>
                  Withdraw
                </option>
                {/* <option className={styles.optionMain} value={"TRANSFER"}>
                  Transfer
                </option>
                <option className={styles.optionMain} value={"CREDIT"}>
                  Credit
                </option>
                <option className={styles.optionMain} value={"DEBIT"}>
                  Debit
                </option>
                <option className={styles.optionMain} value={"PLAN PURCHASE"}>
                  Plan Purchase
                </option> */}
              </select>
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  page: 1,
                  fromDate: "",
                  toDate: "",
                  search: "",
                  transacionType: "",
                  transacionStatus: "COMPLETED",
                  limit: 20,
                });
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <>
          {!data || data.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th>
                    {/* <input type="checkbox" className={styles.checkInputTable} /> */}
                    No.
                  </th>
                  {/* <th>Sender Name</th>
                  <th>Receiver Name</th>
                  <th>Sender | Receiver</th> */}
                  <th>From Address</th>
                  <th>To Adress</th>
                  <th>Transaction Hash</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Date and Time</th>
                  <th>Sender mail | Receiver mail</th>
                  <th>Remarks</th>
                  <th>View</th>
                </tr>
                {data?.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {/* <input
                        type="checkbox"
                        className={styles?.checkInputTable}
                      /> */}
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>
                      {/* <td>
                        {item?.senderEmail ? item.senderEmail : "NA"}
                      </td>
                      <td>
                        {item?.receiverEmail ? item.receiverEmail : "NA"}
                      </td>
                      <td>
                        {item?.senderEmail}
                        {" | "} {item?.receiverEmail}
                      </td> */}
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.formWalletAddress} </span>
                          <IoCopyOutline
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigator.clipboard.writeText(
                                item?.formWalletAddress
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          {item?.toWalletAddress}{" "}
                          <span>
                            <IoCopyOutline
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  item?.toWalletAddress
                                );
                              }}
                            />
                          </span>
                        </div>
                      </td>
                      <td>
                        --{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              item?.transactionHash
                            );
                          }}
                        />
                      </td>

                      <td>{item?.transacionType}</td>
                      <td>{item?.amount}</td>
                      <td>
                        {moment(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                      <td>
                        {item?.senderEmail} | {item?.receiverEmail}
                      </td>
                      <td>{item?.remark}</td>
                      <td>
                        <FaEye
                          color="#3dacf4"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleAdminUserLogin(
                              item?.transacionType === "DEBIT"
                                ? item?.senderEmail
                                : item?.receiverEmail
                            );
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
